/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface RejectResponse
 */
export interface RejectResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RejectResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RejectResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectResponse
     */
    candidateId?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof RejectResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof RejectResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the RejectResponse interface.
 */
export function instanceOfRejectResponse(value: object): value is RejectResponse {
    return true;
}

export function RejectResponseFromJSON(json: any): RejectResponse {
    return RejectResponseFromJSONTyped(json, false);
}

export function RejectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'candidateId': json['candidateId'] == null ? undefined : json['candidateId'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function RejectResponseToJSON(json: any): RejectResponse {
    return RejectResponseToJSONTyped(json, false);
}

export function RejectResponseToJSONTyped(value?: RejectResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'candidateId': value['candidateId'],
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

